import { Component, OnInit } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { LocationsEntity } from '@core/redux/stores';
import { Router } from '@angular/router';
import { LocationCoreService, LocTrackingService } from '@app/core/services';

@Component({
  selector: 'app-assumed-location-banner',
  templateUrl: './assumed-location-banner.component.html',
  styleUrls: ['./assumed-location-banner.component.less']
})
export class AssumedLocationBannerComponent implements OnInit {
  @select((appState) => appState.locationSelected) locationSelected: Observable<LocationsEntity>;
  selectedLocation: LocationsEntity;
  loadBanner = false;

  constructor(
    private router: Router,
    private locationCoreService: LocationCoreService,
    private locationTrackingService: LocTrackingService) {

    this.locationSelected.subscribe((data) => {
      if (data) {
        this.selectedLocation = data;
      }
    });

    locationCoreService.getLatLng().subscribe(success => {
      const fromLat = success.latitude;
      const fromLng = success.longitude;

      if(this.selectedLocation) {
        this.selectedLocation.distance = locationTrackingService.calcCrowInMiles(fromLat, fromLng, this.selectedLocation.latitude, this.selectedLocation.longitude);

        var distanceStr = this.selectedLocation.distance.toFixed(0);
        distanceStr = distanceStr.length > 3 ? '999+ mi' : `${distanceStr} mi`;
        distanceStr = `(${distanceStr})`
  
        this.selectedLocation.distanceStr = isNaN(this.selectedLocation.distance) ? '' : distanceStr;
      }
    });
  }
  public menuLoaded(loaded: boolean) {
    this.loadBanner = loaded;
  }
  ngOnInit() {
  }

  changeLocation() {
    this.router.navigateByUrl('/locations');
  }
}
